import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import LayersIcon from '@material-ui/icons/Layers';
import StorageIcon from '@material-ui/icons/Storage';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import BrushIcon from '@material-ui/icons/Brush';
import CategoryIcon from '@material-ui/icons/Category';
import PublishIcon from '@material-ui/icons/Publish';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:catalog'); // Catalog accessible via landing page
      nav.take('page:kubernetes');
      nav.take('page:notifications');
      nav.take('page:api-docs');
      nav.take('page:catalog-graph');
      nav.take('page:scaffolder');
      nav.take('page:app-visualizer');
      nav.take('page:release-manager'); // Rendered explicitly below

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            <SidebarItem icon={LayersIcon} to="/system/platform" text="Platform" />
            <SidebarItem icon={PublishIcon} to="/release-manager" text="Release Manager" />            
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
            <SidebarDivider />
            <SidebarItem icon={CategoryIcon} text="Other Systems">
              <SidebarSubmenu title="Other Systems">
                <SidebarSubmenuItem title="Data Platform" to="/system/data-platform" icon={StorageIcon} />
                <SidebarSubmenuItem title="Events Platform" to="/system/events-platform" icon={NotificationsActiveIcon} />
                <SidebarSubmenuItem title="Studio" to="/system/studio" icon={BrushIcon} />
              </SidebarSubmenu>
            </SidebarItem>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
